import React, { useRef, useEffect, useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { useIntl } from "react-intl";

import {
  BackgroundKeyToColor
} from "../../../utils/datasources";
import { resolveRichTextWithComponents } from "../../../utils/richText";
import Buttons from "../../internal/buttons/Buttons"
import "./TwoColumnCardMetric.scss";
import WidgetWrapper from "../../internal/widgetWrapper/WidgetWrapper";
import ModalHelper from "../../../utils/modalHelper";

const TwoColumnCardMetric = (blok) => {
  const intl = useIntl();
  const meterRef = useRef();
  const [energyNumber, setEnergyNumber] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);

  const {
    background_color,
    cta_link,
    cta_text,
    header_text,
    is_modal,
    cta_color,
    modal_id,
    modal
  } = blok.blok;
  const backgroundColor = BackgroundKeyToColor(background_color);
  const buttonProps = {
    text: cta_text,
    url: cta_link,
    textColor: cta_color,
    isModal: is_modal,
    modalId: modal_id,
    modal: modal
  };
  useEffect(() => {
    window.addEventListener("scroll", scrollHandler);

    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  useEffect(() => {
    let interval = null;
    if (energyNumber < 100 && hasAnimated) {
      interval = setInterval(() => {
        setEnergyNumber((prevCount) => prevCount + 1);
      }, 10);
    }

    return () => clearInterval(interval);
  });

  const scrollHandler = () => {
    if (window.pageYOffset - window.innerHeight >= meterRef.current.offsetTop / 2) {
      setHasAnimated(true);
      meterRef.current.className = "animation-col onScreen";
    }
  };
  return (
    <WidgetWrapper blok={blok.blok}>
      <Container className="two-column-card-metric-container">
        <Row className="normalize-space">
          <Col className="justify-content-center normalize-space-col">
          {resolveRichTextWithComponents(header_text)}
            {cta_text ? (
              <div className="general-button-wrapper">
                {modal ? <ModalHelper buttonProps={buttonProps} /> : <Buttons buttonProps={buttonProps} />}
                {/* <Buttons buttonProps={buttonProps} /> */}
              </div>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col
            className="justify-content-center animation-col"
            style={{ padding: "0px", position: "absolute", bottom: "0px", left: "0px" }}
            ref={meterRef}
          >
            <div className="gauge-text">
              <div>{energyNumber}</div>
              <h4>{intl.messages["component.panel.two_column_card_metric.title"]}</h4>
            </div>
            <div id="svg-wrapper">
              <svg
                id="meter"
                viewBox="0 0 530 395"
                preserveAspectRatio="xMaxYMin meet"
              >
                <g className="svg-group-wrapper">
                <path
                  className="path"
                  d="M32,345 a150,150 0 1, 1 465 0"
                  fill="none"
                  pathLength="145"
                  id="circle"
                />
                <path
                  className="cover-path"
                  d="M32,345 a150,150 0 1, 1 465 0"
                  fill="none"
                  stroke={backgroundColor}
                />
                </g>
              </svg>
            </div>
          </Col>
        </Row>
      </Container>
    </WidgetWrapper>
  );
};

export default TwoColumnCardMetric;
